import Box from '@mui/material/Box';
import Modal from '@mui/material/Modal';
import { IconButton, Stack, SvgIcon, Typography } from '@mui/material';
import {
  AppFormikTextFieldNumber,
  AppPrimaryButton,
  AppPrimaryButtonOutlined,
} from 'shared/components/AppComponents';
import { Formik } from 'formik';

import { TokenCreationScheme } from 'validators/TokenCreationScheme';
import { ReactComponent as Close } from 'assets/images/ic_close.svg';
import { EnterpriseService } from 'services/EnterpriseService';
import { Utils } from 'shared/helpers';
import { ReactElement } from 'react';

interface TokenCreationModalProps {
  onClose: () => void;
  getTokenList: () => void;
  isTokenModalOpen: boolean;
}

const TokenCreationModal = (props: TokenCreationModalProps): ReactElement => {
  const { onClose, getTokenList, isTokenModalOpen } = props;

  const handleCreateToken = (values: any): void => {
    const expiryDays = parseInt(values.tokendays, 10);
    EnterpriseService.getEnterpriseToken(expiryDays)
      .then((res) => {
        Utils.handleSuccessResponse(res);
        getTokenList();
      })
      .catch((error) => {
        Utils.handleErrorResponse(error);
      })
      .finally(() => {
        onClose();
      });
  };

  return (
    <Box>
      <Modal
        open={isTokenModalOpen}
        disableEscapeKeyDown
        onClose={onClose}
        aria-labelledby="parent-modal-title"
        aria-describedby="parent-modal-description"
      >
        <Formik
          initialValues={{
            tokendays: '',
          }}
          enableReinitialize
          validateOnMount
          validationSchema={TokenCreationScheme}
          onSubmit={handleCreateToken}
        >
          {({ handleSubmit }) => (
            <Box
              className="container-token-creation-modal"
              sx={{
                width: { xs: '100%', sm: 'auto' },
                maxWidth: { xs: '90%', sm: 480 },
                px: { xs: 2, sm: 3 },
                py: { xs: 2, sm: 2.5 },
                boxSizing: 'border-box',
              }}
            >
              <Box
                display="flex"
                justifyContent="flex-end"
                className="closemodal"
              >
                <IconButton onClick={onClose}>
                  <SvgIcon
                    component={Close}
                    inheritViewBox
                    className="view-icon"
                    fontSize="inherit"
                  />
                </IconButton>
              </Box>
              <Typography variant="h2" id="parent-modal-title">
                Create New Submission Token
              </Typography>

              <Box className="container-token-creation-detail">
                <AppFormikTextFieldNumber
                  name="tokendays"
                  placeholder="1"
                  label="Token Expiry (days)"
                  outerLabel
                />
              </Box>

              <Stack
                className="action-to-complete-creation-token"
                direction="row-reverse"
              >
                <AppPrimaryButton title="Create Token" onClick={handleSubmit} />
                <AppPrimaryButtonOutlined title="Cancel" onClick={onClose} />
              </Stack>
            </Box>
          )}
        </Formik>
      </Modal>
    </Box>
  );
};

export default TokenCreationModal;
